// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { makeObservable, observable } from 'mobx';

// Use "NotificationItem" because there is already a "Notification" object.

export interface NotificationItemDTO {
  id: number;
  customerId: number;
  customer: string;
  assetId: number;
  asset: string;
  jobRequestId: number;
  jobRequest: string;
  date: string;
  event: string;
}

export default class NotificationItem {
  id: number;
  @observable customerId: number;
  @observable customer: string;
  @observable assetId: number;
  @observable asset: string;
  @observable jobRequestId: number;
  @observable jobRequest: string;
  @observable date: string;
  @observable event: string;

  constructor(dto: Partial<NotificationItemDTO>) {
    this.update(dto);
    makeObservable(this);
  }

  get asJson(): NotificationItemDTO {
    return {
      id: this.id,
      customerId: this.customerId,
      customer: this.customer,
      assetId: this.assetId,
      asset: this.asset,
      jobRequestId: this.jobRequestId,
      jobRequest: this.jobRequest,
      date: this.date,
      event: this.event,
    };
  }

  update(newData: Partial<NotificationItemDTO>): NotificationItemDTO {
    const allData = { ...this.asJson, ...newData }; // merge new data to existing data.  New data does not need to be complete (Partial).

    Object.assign(this, allData);

    return this.asJson;
  }
}
